import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
} from 'react';

type RegexContextType = {
  isRegexActive: boolean;
  regexReplace: (name: string) => string;
  breakableSlashRegexReplace: (name: string) => string;
  toggleRegex: () => void;
};

const RegexContext = createContext<RegexContextType | undefined>(undefined);

export const useRegex = () => {
  const context = useContext(RegexContext);
  if (context === undefined) {
    throw new Error('useRegex must be used within a RegexProvider');
  }
  return context;
};

export const RegexProvider: React.FC<PropsWithChildren> = ({children}) => {
  const [isRegexActive, setIsRegexActive] = useState(true);
  const regexReplace = (name: string) => {
    return isRegexActive ? name.replace(/(\d+_)/g, '') : name;
  };
  const toggleRegex = () => {
    setIsRegexActive(prevValue => !prevValue);
  };

  const breakableSlashRegexReplace = (name: string) => {
    return name.replace(/\//g, '/\u200B');
  };

  return (
    <RegexContext.Provider
      value={{
        isRegexActive,
        toggleRegex,
        regexReplace,
        breakableSlashRegexReplace,
      }}
    >
      {children}
    </RegexContext.Provider>
  );
};
